const UTILS = {};

UTILS.generateCCB = function (placementId) {
    return UTILS.crc32((Date.now() || new Date().getTime()) + ":" + "ajio.com" + ":" + placementId + ":" + Math.random(10) * 100);
};

UTILS.crc32 = function (str) {
    for (var a, o = [], c = 0; c < 256; c++) {
        a = c;
        for (var f = 0; f < 8; f++) a = 1 & a ? 3988292384 ^ (a >>> 1) : a >>> 1;
            o[c] = a;
    }

    for (var n = -1, t = 0; t < str.length; t++)
        n = (n >>> 8) ^ o[255 & (n ^ str.charCodeAt(t))];
    return (-1 ^ n) >>> 0;
};

// CCB Generator functions have been provided by jio ads team.

UTILS.getCCB = function (key="") {
    let modifiedKey = key.replace(/ /g, "_");
    let jioAdsCCBData = JSON.parse(sessionStorage.getItem('jioAdsCCB') || '{}');
    if(jioAdsCCBData[modifiedKey])
        return jioAdsCCBData[modifiedKey];
    else{
        let ccb= UTILS.generateCCB("");
        jioAdsCCBData = {
            ...jioAdsCCBData,
            [modifiedKey]: ccb
        }
        sessionStorage.setItem('jioAdsCCB', JSON.stringify(jioAdsCCBData));
        return ccb;
    }
}

export default UTILS;
